import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { axiosDelete, axiosGet } from '../api/axios';

export interface Count {
  count: number;
}

export interface UserSummary {
  first_name?: string;
  last_name?: string;
  display_name: string;
}

export interface ConnectionBlock {
  id: number;
  from_user: UserSummary;
  to_user: UserSummary;
}

export interface ConnectionBlocksFilter {
  page: number;
  limit: number;
  search?: string;
}

export interface ConnectionBlocksResponse {
  connection_blocks: ConnectionBlock[];
  count: number;
}

const getConnectionBlocks = async (filters: ConnectionBlocksFilter): Promise<ConnectionBlocksResponse> => {
  const { page, limit, search } = filters;
  return await axiosGet('/users/connection_blocks', { page, limit, search }, 'v3').then((response) => response.data);
};

export const useConnectionBlocks = (filters: ConnectionBlocksFilter) => {
  const queryKey = ['connectionBlocks', filters.page, filters.limit, filters.search];
  return useQuery<ConnectionBlocksResponse>(queryKey, () => getConnectionBlocks(filters), {
    refetchOnWindowFocus: false,
  });
};

export const useRemoveConnectionBlock = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (input: { id: number; reason: string }) =>
      axiosDelete(`/users/connection_blocks/${input.id}`, { reason: input.reason }, 'v3'),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['connectionBlocks'] });
      },
    },
  );
};
